module.exports = __webpack_public_path__ + "static/media/contract-4545562_640_color.a0cfe728.png";